import { getI18n } from './i18nAccessor';

export function formatMoney(amount, currency) {
	if (amount == null) return '-';
	const value = Number(amount) / 100;
	const i18n = getI18n();
	const locale = i18n?.global?.locale?.value || 'en';
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: (currency || 'USD').toUpperCase(),
		maximumFractionDigits: 0
	}).format(value);
}

export function formatNumber(num) {
	const i18n = getI18n();
	const locale = i18n?.global?.locale?.value || 'en';
	return Number(num).toLocaleString(locale);
}

export function formatDate(date, options = {}) {
	const i18n = getI18n();
	const locale = i18n?.global?.locale?.value || 'en';
	const d = (date instanceof Date) ? date : new Date(date);
	return d.toLocaleString(locale, options);
}
